import { icuOptions } from '../constants/icu-options';
export const createI18n = (locale, messages, initI18n) => {
    const i18n = initI18n({ locale, messages, icuOptions });
    i18n.init();
    return i18n;
};
//# sourceMappingURL=i18n-provider.js.map